/* eslint-disable radix */
/* eslint-disable no-param-reassign */

import { ref } from "vue";
import maxZIndex from "./useMaxZIndex";

export default () => {
  const scrollerRef = ref();

  const onScrollerUpdate = () => {
    const scrollerItems = [
      // NB: this workaround is tightly coupled with vue-virtual-scroller
      ...document.querySelectorAll(".vue-recycle-scroller__item-view")
    ];

    // Set max z-index based on number of new stacking contexts created
    maxZIndex.value = Math.max(scrollerItems.length + 1, 20);

    const getPositionFromTransformTranslateY = (element: HTMLElement) =>
      parseInt(element.style.transform.match(/\((.*?)\)/)[1]);

    // Sort positioned items based on `translateY` value
    const orderedScrollerItems = scrollerItems.sort((a, b) => {
      const aPos = getPositionFromTransformTranslateY(<HTMLElement>a);
      const bPos = getPositionFromTransformTranslateY(<HTMLElement>b);
      return aPos - bPos;
    });

    // Set z-index in descending order
    orderedScrollerItems.forEach((scrollerItem, index) => {
      const position = getPositionFromTransformTranslateY(<HTMLElement>(
        scrollerItem
      ));
      if (position > -1) {
        (<HTMLElement>scrollerItem).style.zIndex = String(
          orderedScrollerItems.length - index
        );
      }
    });
  };

  return { scrollerRef, onScrollerUpdate };
};
